
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-effects",
      function () {
        return require("private-next-pages/special-effects.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-effects"])
      });
    }
  